import styled from "styled-components"
import { lighten } from "polished";

export const StepperContainer = styled.div`
  // width: 100%;
  max-height: 100%;
  width: calc(768px - 2rem);
  margin: 0 auto;
  padding: 1rem 2rem 0 2rem;
  background-color: #f8f9fa;
  border-radius: ${(props) => props.corner};
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  position: relative;
  @media (max-width: 768px) {
    width: calc(100% - 2rem);
    padding: 1rem 1rem 0 1rem;
  }
`

export const StepperWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  position: relative;
  margin: 2rem 100px 0 100px;

  &::before {
    content: '';
    position: absolute;
    background: ${(props) => ( props.color ? props.color : "#2196f3" )};
    height: 2px;
    width: calc(100% - 60px);
    top: 30%;
    transform: translateY(-50%);
    left: 30px;
    z-index: 1;
  }

  @media (max-width: 768px) {
    margin: 2rem 0 0 0;
  }
`

export const StepItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 2;
`

export const StepNumber = styled.div`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: ${(props) => (props.completed ? props.color ? props.color : "#2196f3" : props.active ? props.color ? lighten(0.3, props.color) : "#bbdefb" : "#fff")};
//   border: 2px solid ${(props) => (props.completed ? "#2196f3" : props.active ? "#2196f3" : "#e0e0e0")};
  border: 2px solid ${(props) => props.color ? props.color : "#2196f3"};
  color: ${(props) => (props.completed ? "#fff" : props.active ? props.color ? props.color : "#2196f3" : "#757575")};
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 8px;
`

export const StepLabel = styled.span`
  color: ${(props) => (props.active ? props.color ? props.color : "#2196f3" : "#000")};
  font-size: 16px;
  font-weight: 500;
  @media (max-width: 768px) {
    font-size: 14px;
  }
`

export const FormContainer = styled.div`
//   background: #fff;
  padding: 2rem;
  border-radius: 8px;
//   box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
@media (max-width: 768px) {
    padding: 2rem 0;
  }
`

export const FormTitle = styled.h2`
  font-size: 28px;
  color: #333;
  margin-bottom: 1rem;
`

export const FormDescription = styled.p`
  font-size: 18px;
  color: #000;
  margin-bottom: 2rem;
`

export const FormGroup = styled.div`
  margin-bottom: 1.5rem;
`

export const Label = styled.label`
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  color: #333;
  font-size: 16px;
`

export const Input = styled.input`
  width: calc(100% - 1.5rem);
  padding: 0.75rem;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  font-size: 16px;
  transition: border-color 0.2s;

  &:focus {
    outline: none;
    border-color: #2196f3;
  }

  &:disabled {
    color: #808080;
  }

  &:invalid {
    border-color: #f44336;
  }

  &.pass{
    width: calc(100% - 2rem);
  }
`
export const Textarea = styled.textarea`
  width: calc(100% - 1.5rem);
  padding: 0.75rem;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  font-size: 18px;
  transition: border-color 0.2s;
  min-height: 76px;

  &:focus {
    outline: none;
    border-color: #2196f3;
  }
  
  &:disabled {
    color: #808080;
  }

  &:invalid {
    border-color: #f44336;
  }

  &.pass{
    width: calc(100% - 2rem);
  }
`

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 2rem;
  gap: 30px;
`

export const Button = styled.button`
  padding: 0.75rem 1.5rem;
  border-radius: ${(props) => (props.corner ? props.corner : "10px")};
  font-weight: 700;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.2s;
  border: none;
  min-width: 150px;

  ${(props) =>
    props.variant === "primary"
      ? `
    background: ${props.color ? props.color : "#2196f3"};
    color: white;
    &:hover {
      background: ${props.color ? lighten(0.1, props.color) : "#1976d2"};
    }
  `
      : `
    background: none;
    color: #333;
    border: 1px solid ${props.color ? props.color : "#2196f3"};
  `}

  @media (max-width: 768px) {
    font-size: 14px;
    min-width: 120px;
  }
`

export const AlertBox = styled.div`
  background-color: #f1f8e9;
  border: 1px solid #c5e1a5;
  border-radius: 4px;
  padding: 1rem;
  margin-bottom: 1.5rem;
  font-size: 16px;
  color: #33691e;
`

export const LanguageToggle = styled.button`
  background: none;
  border: none;
  color: #2196f3;
  font-size: 14px;
  cursor: pointer;
  position: absolute;
  top: 1rem;
  right: 1rem;

  &:hover {
    text-decoration: underline;
  }
`
export const StyledSelect = styled.select`
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
  &:focus {
    border-color: #007bff;
    outline: none;
  }
  &:disabled {
    background-color: #e9ecef;
    cursor: not-allowed;
  }
`;

